export default "__VITE_ASSET__bUDHNeIy__"